import { render, staticRenderFns } from "./M_user.vue?vue&type=template&id=24400024&scoped=true&"
import script from "./M_user.vue?vue&type=script&lang=js&"
export * from "./M_user.vue?vue&type=script&lang=js&"
import style0 from "./M_user.vue?vue&type=style&index=0&id=24400024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24400024",
  null
  
)

export default component.exports